import { Pipe, PipeTransform } from '@angular/core';
import { StatusColorType } from '@ui/components';
import { SharedStatus } from '../../interfaces/status.enum';

const statusColorMap: Record<string, StatusColorType> = {
  [SharedStatus.Pending]: 'task',
  [SharedStatus.Submitted]: 'task',
  [SharedStatus.Approved]: 'positive',
  [SharedStatus.Rejected]: 'negative',
  [SharedStatus.Reversed]: 'warning',
  [SharedStatus.Resubmitted]: 'warning',
  [SharedStatus.PartiallyApproved]: 'warning',
  [SharedStatus.Draft]: 'task',
  [SharedStatus.Canceled]: 'negative',
};

@Pipe({
    name: 'sharedStatusColor',
    standalone: false
})
export class SharedStatusColorPipe<T> implements PipeTransform {
  transform(status: T): StatusColorType {
    return statusColorMap[status] ?? 'task';
  }
}
